export enum MembershipPlanPeriodsType {
  Annual = 'Annual',
  Days_14 = 'Days_14',
  Days_30 = 'Days_30',
}
